import { Card } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import { titlePanelMixin } from 'modules/core/theme/mixins';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';

const { Title: TitleUI } = Card;

const responsiveLayoutMixin = css`
  position: relative;
  height: auto;
  padding: 12px 15px;

  & > span {
    flex-wrap: wrap;
    width: 100%;
    max-width: 100%;
    margin-right: 0;

    & > .row {
      width: 100%;
      flex-basis: 100%;
      margin-top: 8px;
    }
  }

  & > div {
    position: absolute;
    right: 15px;
    top: 12px;
  }
`;

export const Title = styled(TitleUI)`
  ${titlePanelMixin};
  padding: 12px 15px;
  min-height: 54px;
  height: auto;
  font-size: ${({ theme: { fontSize } }) => fontSize.sm};
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  & > span {
    margin-right: 10px;
    line-height: 2;
    display: flex;
    align-items: center;
    flex: 1;
    max-width: 700px;
  }

  @media (max-width: ${WindowBreakpoints.small}px) {
    font-size: ${({ theme: { fontSize } }) => fontSize.normal};
  }

  @media (min-width: ${WindowBreakpoints.medium + 1}px) and (max-width: ${WindowBreakpoints.large}px) {
    ${responsiveLayoutMixin};
  }

  @media (max-width: ${WindowBreakpoints.medium}px) {
    ${responsiveLayoutMixin};

    & > span > .row {
      --bs-gutter-x: 0;
    }
  }
`;
